<template>
  <div>
    <table style="width: 100%; border: none" v-if="rows.length">
      <thead>
      <tr>
        <th v-for="(header, index) in headers" :key="index" :style="{width: '30%'}">{{ header }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
        <td v-for="(value, key) in row" :key="key">{{ value }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'DataChanged',
  props: {
    data: {
      type: String,
      required: false,
    },
    mainPhoneNumberList: {
      type: Array,
      required: false
    },
    providerList: {
      type: Array,
      required: false
    },
    phoneNumberStatusList: {
      type: Array,
      required: false
    },
    phoneNumberClientList: {
      type: Array,
      required: false
    },
    legalList: {
      type: Array,
      required: false
    },
  },
  data () {
    return {
      headers: ['Trường', 'Giá trị cũ', 'Giá trị mới'],
      rows: []
    }
  },
  mounted () {
    this.buildHtml()
  },
  methods: {
    buildHtml () {
      if (this.data) {
        let correctedJsonString = this.data.replace(/'/g, '"').replace(/\(([^)]+)\)/g, '[$1]')
        Object.keys(JSON.parse(correctedJsonString)).forEach(key => {
          const str = JSON.parse(correctedJsonString)[key]
          let value1 = str[0]
          let value2 = str[1]
          const row = {
            field: this.convertLabel(key),
            oldValue: this.convertValue(key, value1),
            newValue: this.convertValue(key, value2)
          }
          this.rows.push(row)
        })
      }
    },
    convertValue (key, value) {
      let found = ''
      switch (key) {
        case 'main_phone_number':
          found = this.mainPhoneNumberList.find(item => item.value === value)
          if (found !== undefined) {
            return found.text
          }
          return value
        case 'provider':
          found = this.providerList.find(item => item.value === value)
          if (found !== undefined) {
            return found.text
          }
          return value
        case 'legal':
          found = this.legalList.find(item => item.value === value)
          if (found !== undefined) {
            return found.text
          }
          return value
        case 'phone_number_client':
          found = this.phoneNumberClientList.find(item => item.value === value)
          if (found !== undefined) {
            return found.text
          }
          return ''
        case 'phone_number_status':
          found = this.phoneNumberStatusList.find(item => item.value === value)
          if (found !== undefined) {
            return found.text
          }
          return value
        case 'viettel_using_status':
        case 'mobifone_using_status':
        case 'vinaphone_using_status':
        case 'other_using_status':
          return this.get_using_status(value)
        case 'viettel_unlocking_status':
        case 'mobifone_unlocking_status':
        case 'vinaphone_unlocking_status':
        case 'other_unlocking_status':
          return this.get_unlocking_status(value)
        default:
          return value
      }
    },
    get_using_status (value) {
      switch (value) {
        case 'OPEN':
          return 'Mạng mở'
        case 'LOCK':
          return 'Mạng khóa'
        case 'USING':
          return 'Mạng đang sử dụng'
        default:
          return ''
      }
    },
    get_unlocking_status (value) {
      switch (value) {
        case 'SENT_PROVIDER':
          return 'Đã gửi NCC'
        case 'OPENED':
          return 'Đã mở'
        case 'WRONG_REPORT':
          return 'NCC báo sai'
        default:
          return ''
      }
    },
    convertLabel (value) {
      switch (value) {
        case 'main_phone_number':
          return 'Số chủ'
        case 'provider':
          return 'NCC'
        case 'legal':
          return 'Pháp nhân'
        case 'phone_number_client':
          return 'KH sử dụng'
        case 'phone_number_status':
          return 'Trạng thái số'
        case 'brand':
          return 'Brand'
        case 'init_fee':
          return 'Phí khởi tạo'
        case 'open_fee':
          return 'Phí mở'
        case 'other_fee':
          return 'Phí khác'
        case 'operate_fee':
          return 'Phí duy trì'
        case 'note':
          return 'Ghi chú'
        case 'phone_number':
          return 'SĐT'
        case 'pickup_date':
          return 'Ngày lấy'
        case 'lock_count':
          return 'Số lần bị khoá'
        case 'client_use_date':
          return 'Ngày khách lấy'
        case 'viettel_using_status':
          return 'Trạng thái sử dụng Viettel'
        case 'viettel_unlocking_status':
          return 'Trạng thái khóa số Viettel'
        case 'mobifone_using_status':
          return 'Trạng thái sử dụng Mobifone'
        case 'mobifone_unlocking_status':
          return 'Trạng thái khóa số Mobifone'
        case 'vinaphone_using_status':
          return 'Trạng thái sử dụng Vinaphone'
        case 'vinaphone_unlocking_status':
          return 'Trạng thái khóa số Vinaphone'
        case 'other_using_status':
          return 'Trạng thái sử dụng Ngoại mạng'
        case 'other_unlocking_status':
          return 'Trạng thái khóa số Ngoại mạng'
        case 'pic':
          return 'Nhân viên kĩ thuật'
        default:
          return value
      }
    }
  },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/phone_number_management/DataChanged.vue